export default __webpack_public_path__ + "static/media/logo_negativo.9095a8b9.svg";